import { render, staticRenderFns } from "./userDashboardInteractions.vue?vue&type=template&id=318fc5e8"
import script from "./userDashboardInteractions.vue?vue&type=script&lang=js"
export * from "./userDashboardInteractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports